import { Component, Input, OnInit } from '@angular/core';
import { Activity } from 'app/activity/models/activity.model';

@Component({
  selector: 'siq-activity-error',
  templateUrl: './activity-error.component.html',
  styleUrls: ['./activity-error.component.scss']
})
export class ActivityErrorComponent implements OnInit {

  @Input() activity: Activity;

  constructor() { }

  ngOnInit() {
  }

}
